import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';

@Injectable({
    providedIn: 'root',
})

export class ServicesApiService {

    constructor(private apiCommonService: ApiCommonService) { }

    getGridRecords(event: any, searchQuery: string, filterQuery: string): Observable<object> {
        return this.apiCommonService.getGridRecords('Services', event, searchQuery, '', filterQuery);
    }

    getRecord(serviceId: string): Observable<any> {
        return this.apiCommonService.getRecord('Services', serviceId);
    }

    getCategories(): Observable<any> {
        return this.apiCommonService.get(`Services/CategoryLookUp`);
    }

    getAccountMappedService(accountId: any, isAutoPopulate: any): Observable<any> {
        return this.apiCommonService.get(`Accounts/AllServicesByAccount?AccountId=${accountId}&IsAutoPopulate=${isAutoPopulate}`);
    }

    getRevenueCategories(): Observable<any> {
        return this.apiCommonService.get(`Services/RevenueCategoryLookUp`);
    }

    // Create New Service
    createService(inputData: object): Observable<any> {
        return this.apiCommonService.post('Services', inputData);
    }

    edit(leadId: string): Observable<object> {
        return this.apiCommonService.get(`Services/Edit?Id=${leadId}`);
    }

    // Update New Service
    updateService(inputData: object): Observable<any> {
        return this.apiCommonService.post('Services/Update', inputData);
    }

    updateServices(data: any): Observable<any> {
        return this.apiCommonService.post('Services/Updates', data);
    }

    // Update Applied To All
    updateAppliedAll(inputData: object): Observable<object> {
        return this.apiCommonService.update('Services/UpdateAppliedToAll', inputData);
    }

    // Update Status
    updateServiceStatus(inputData: object): Observable<object> {
        return this.apiCommonService.update('Services/Delete', inputData);
    }

    updateServiceTaxConfig(inputData: object): Observable<object> {
        return this.apiCommonService.update('Services/TaxConfig', inputData);
    }

    getCalculatedCost(serviceId: string): Observable<any> {
        return this.apiCommonService.get(`Services/CalculatedCost?ServiceId=${serviceId}`);
    }

    getServiceLookup(): Observable<any> {
        return this.apiCommonService.get(`Services/LookUp`);
    }

    getDefaultServices(queryString: any): Observable<any> {
        return this.apiCommonService.get(`Accounts/DefaultServices?${queryString}`);
    }

    exportServices(event: any, searchQuery: string, filterQuery: string): Observable<object> {
        return this.apiCommonService.export('Services/Export', event, searchQuery, filterQuery, '');
    }

    getServiceMappedAccountGrid(serviceId: any): Observable<any> {
        return this.apiCommonService.get(`Accounts/BrowseServiceAccounts?ServiceId=${serviceId}`);
    }

    deleteServiceMappedToAccount(inputData: object): Observable<any> {
        return this.apiCommonService.post('Accounts/UpdateServiceAccounts', inputData);
    }

}
